<template>
分配客户资源
</template>

<script>
export default {
  name: "distribute_client"
}
</script>

<style scoped>

</style>